import type { TariffGroup } from '@/models'

const usePriceFilters = () => {
  const { tariffGroups } = storeToRefs(useTariffStore())
  const { seatQuotaJsonScheme, entranceQuotaJsonScheme } = storeToRefs(
    useQuotaStore(),
  )

  const priceFiltersVisible = ref(false)
  /**
   * Фильтры, которые применены
   */
  const activeFilters = reactive<{ tariffGroups: TariffGroup[] }>({
    tariffGroups: [],
  })
  /**
   * Все фильтры
   */
  const filters = reactive<{ tariffGroups: TariffGroup[] }>({
    tariffGroups: tariffGroups.value ? [...tariffGroups.value!] : [],
  })

  const availableFilters = computed(() => {
    const fullSeatQuota = seatQuotaJsonScheme.value
    const fullEntranceQuota = entranceQuotaJsonScheme.value

    if (!fullSeatQuota || !fullEntranceQuota) return filters.tariffGroups

    const seatQuotas = [...new Set(Object.values(fullSeatQuota))]
    const entranceQuotas = [...new Set(Object.values(fullEntranceQuota))]

    return filters.tariffGroups.filter((tariffGroup) => {
      return (
        seatQuotas.includes(tariffGroup.id) ||
        entranceQuotas.includes(tariffGroup.id)
      )
    })
  })

  /**
   * Обрабатывает событие 'hide-price-filters'.
   * Обнуляет массив с активными фильтрами, а также массив со всеми доступными ценовыми фильтрами,
   * затем скрывает компонент TariffGroupChecklist
   */
  const hidePriceFilters = () => {
    filters.tariffGroups = []
    activeFilters.tariffGroups = []
    priceFiltersVisible.value = false
  }

  /**
   * Обрабатывает событие 'show-price-filters'.
   * Переданные тарифные группы устанавливает в качестве доступных ценовых фильтров
   * и отображает компонент TariffGroupChecklist, массив с активными фильтрами обнуляет
   * @param {TariffGroup[]} tariffGroups - массив ценовых групп всей площадки или выбранного сектора
   */
  const showPriceFilters = (tariffGroups: TariffGroup[]) => {
    filters.tariffGroups = tariffGroups
    activeFilters.tariffGroups = []
    priceFiltersVisible.value = true
  }

  return {
    priceFiltersVisible,
    activeFilters,
    filters,
    hidePriceFilters,
    showPriceFilters,
    availableFilters,
  }
}

export { usePriceFilters }
